var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStorePreviousInt from '../../../helpers/hooks/useStorePreviousInt';
import { useAppDispatch } from '../../../store';
import { updateSubtitleFontSize } from '../../../store/slices/speechServicesSlice';
const SubtitleFontSize = () => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [fontSize, setFontSize] = useState(14);
    const previousFontSize = useStorePreviousInt(fontSize);
    useEffect(() => {
        if (previousFontSize && fontSize !== previousFontSize) {
            dispatch(updateSubtitleFontSize(fontSize));
        }
    }, [dispatch, fontSize, previousFontSize]);
    return (_jsxs("div", { className: "flex items-center justify-between mt-2", children: [_jsx("p", { className: "text-sm dark:text-darkText", children: t('speech-services.subtitle-font-size') }), _jsxs("section", { className: "flex items-center w-[150px] sm:w-[250px]", children: [_jsx("input", { type: "range", min: 0, max: 30, step: 1, value: fontSize, onChange: (event) => {
                            setFontSize(event.target.valueAsNumber);
                        }, className: "range flex-1" }), _jsx("p", { className: "w-10 text-center text-sm dark:text-white", children: fontSize })] })] }));
};
_react_refresh_temp_1 = SubtitleFontSize;
$RefreshReg$(_react_refresh_temp_1, "SubtitleFontSize");
_react_refresh_temp_2(SubtitleFontSize, "3QpxGns2EQBpQAKvCUsQC7hcrs0=", false, () => [useTranslation, useAppDispatch, useStorePreviousInt]);
export default SubtitleFontSize;
